import { Collapse, styled } from '@mui/material';
import { IntervalLayoutProps } from '../types';
import { EntrySidebar } from './EntrySidebar';

const ReportColumns = styled('div')({
    display: 'flex',
    alignItems: 'stretch',
});

const ReportMain = styled('div')({
    flex: 1,
    minWidth: 0,
});

const SidebarCollapse = styled(Collapse)({
    'flexShrink': 0,
    'display': 'flex',
    'overflow': 'clip',
    '& .MuiCollapse-wrapper, & .MuiCollapse-wrapperInner': {
        display: 'flex',
        height: 'auto',
    },
});

export default function View({
    children,
    editor,
    editorOpen,
    onEditorExited,
}: IntervalLayoutProps) {
    return (
        <ReportColumns>
            <ReportMain>{children}</ReportMain>
            <SidebarCollapse
                orientation='horizontal'
                in={editorOpen && !!editor}
                onExited={onEditorExited}
                unmountOnExit>
                {editor && <EntrySidebar key={editor.draft.uuid} {...editor} />}
            </SidebarCollapse>
        </ReportColumns>
    );
}
